var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9857 67.2385H28V32H91.9929V67.2385H91.9857ZM30.14 65.0985H89.8529V34.14H30.14V65.0985Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9678 46.6238H34.4199V39.1338H51.9678V46.6238ZM36.5599 44.4838H49.8279V41.2738H36.5599V44.4838Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0989 51.1025H34.4199V53.2425H66.0989V51.1025Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3218 57.9648H34.4199V60.1048H54.3218V57.9648Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0814 56.8955H76.9414V60.0413H79.0814V56.8955Z",
    fill: "#2DCDAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0814 39.2051H76.9414V42.2795H79.0814V39.2051Z",
    fill: "#2DCDAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.324 57.9648H76.6918C74.1737 57.9648 72.1264 55.9746 72.1264 53.5279H74.2664C74.2664 54.7976 75.3507 55.8248 76.6918 55.8248H79.324C80.8219 55.8248 82.0417 54.6621 82.0417 53.2426C82.0417 52.5578 81.7635 51.9158 81.2571 51.4307C80.7435 50.9314 80.0515 50.6603 79.324 50.6603H76.6918C74.0168 50.6603 71.834 48.5417 71.834 45.9381C71.834 44.6683 72.3476 43.4771 73.2678 42.5854C74.1808 41.7009 75.4006 41.2158 76.6918 41.2158H79.324C81.842 41.2158 83.8893 43.206 83.8893 45.6527H81.7493C81.7493 44.383 80.665 43.3558 79.324 43.3558H76.6918C75.957 43.3558 75.2722 43.6269 74.7586 44.1262C74.2522 44.6113 73.974 45.2604 73.974 45.9381C73.974 47.3647 75.1938 48.5203 76.6918 48.5203H79.324C80.6151 48.5203 81.8277 49.0054 82.7479 49.8899C83.6753 50.7816 84.1817 51.9728 84.1817 53.2426C84.1817 55.8462 82.0061 57.9648 79.324 57.9648Z",
    fill: "#2DCDAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6581 83.2028H34.2622L28.6055 78.8158L34.2693 74.4288H90.6652C91.3999 74.4288 91.9991 75.028 91.9991 75.7628V81.876C91.9849 82.6036 91.3928 83.2028 90.6581 83.2028ZM34.9969 81.0628H89.852V76.5688H34.9969L32.1008 78.8158L34.9969 81.0628Z",
    fill: "#00A3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6056 87.2688H74.4375V85.1288H87.6056C87.6626 85.1288 87.7126 85.0789 87.7126 85.0218V82.1328H89.8526V85.0218C89.8454 86.263 88.8396 87.2688 87.6056 87.2688Z",
    fill: "#00A3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7259 75.499H69.5859V82.133H71.7259V75.499Z",
    fill: "#00A3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7044 75.4989H33.5645V82.1329H35.7044V75.4989Z",
    fill: "#00A3FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4466 75.4989H65.3066V82.1329H67.4466V75.4989Z",
    fill: "#00A3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 118,
    height: 118,
    rx: 31,
    stroke: "#09547E",
    strokeOpacity: 0.05,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.1513d31bba952a1d234d1f379823f63a.svg";
export { ForwardRef as ReactComponent };